import {schema, TIME} from '@/const';
import {getRandomInt} from '@/utils/helpers';
const switchDelay = getRandomInt(10*TIME.MINUTE, 20*TIME.MINUTE);
let indexTimeout = null;

const RESERVE_URL = process.env.VUE_APP_URL_RESERVE && process.env.VUE_APP_URL_RESERVE
    .replace(/[\[\]]/g, '')
    .split(',')
    .map((s) => s.trim());


export const URL_INDEX = {
  count: 0,
};

/**
 * Switches the current URL to the next one in the API_BASE_URLS list.
 *
 * @param {Object} err - Error object containing the request configuration.
 * @param {Function|Object} axios - Axios method to perform the retry request.
 * @return {Promise} - Returns a new request with the updated baseURL.
 */
export function switchUrl(err, axios) {
  const currentUrl = getApiUrl();

  if (err.config.baseURL === currentUrl && URL_INDEX.count < API_BASE_URLS.length - 1) {
    ++URL_INDEX.count;
    clearTimeout(indexTimeout);
    indexTimeout = setTimeout(switchToMainURL, switchDelay);
  }
  err.config.baseURL = getApiUrl();

  return axios({
    ...err.config,
  });
}

/**
 * Checks if there is a reserve URL to switch to.
 *
 * @param {Object} err - Error object containing the request configuration.
 * @return {boolean} - Returns true if there is a reserve URL, otherwise false.
 */
export function hasReserveUrl(err) {
  if (API_BASE_URLS.length === 1) {
    return false;
  }
  if (err.config.baseURL !== getApiUrl()) {
    return true;
  }
  return Boolean(API_BASE_URLS[URL_INDEX.count+1]);
}

/**
 * Returns the current API URL based on the schema and current index.
 *
 * @return {string} - The current API URL.
 */
export function getApiUrl() {
  return API_BASE_URLS[URL_INDEX.count];
}

/**
 * Prepares the API URL by adding the schema and the /api path.
 * @param {string} url - The base URL to prepare.
 * @return {string}
 */
export function prepareApiUrl(url) {
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }
  return `${schema}://${url}/api`;
}

export const API_BASE_URLS = [process.env.VUE_APP_URL].concat(RESERVE_URL || []).map(prepareApiUrl);
/**
 * Switches the current URL back to the main (first in the list).
 */
export function switchToMainURL() {
  clearTimeout(indexTimeout);
  URL_INDEX.count = 0;
  indexTimeout = null;
}
